import toast from "react-hot-toast";
import { sendingEmail, sendSimpleEmailApi } from "../api/sendEmailPdf.api";
import { saveData, uploadPDFBlob } from "../firebase/utility";
export const capitalizeFirstLetter = (str) => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};
export const searchData = (searchInput, setState, duplicateData) => {
  let text = searchInput;
  if (text.length == 0) {
    setState(duplicateData);
  } else {
    let newArray = duplicateData?.filter(function (item) {
      const search = `${item?.id} ${item?.status} ${item?.first_name}${item?.last_name}`;
      const searchUserQuery = search.toUpperCase();
      const textData = text.toUpperCase();
      return searchUserQuery.indexOf(textData) > -1;
    });
    setState(newArray);
  }
};
export const uploadBlobAndSendEmail = async (
  pdfBlob,
  filename,
  docId,
  docType,
  collection,
  setLoading,
  docNumber,
  email,
  type,
  pdfLink,
  ccEmails,
  onSuccess
) => {
  setLoading(true);
  try {
    const pdfLink = await uploadPDFBlob(pdfBlob, `${docNumber}`);
    if (pdfLink) {
      let obj = {
        email: email,
        pdfLink: pdfLink,
        documentType: docType,
        documentNumber: docNumber,
        ccEmails: [ccEmails],
      };
      let isSuccess = false;
      await sendingEmail(obj, (res) => {
        if (res.status === 200) {
          saveData(collection, docId, {
            sendPdf: true,
            pdfLink: pdfLink,
          });
          toast.success(`PDF ${type === "resend" ? "resent" : "sent"} successfully`);
          isSuccess = true;
          if (typeof onSuccess === "function") {
            onSuccess(res);
          }
        } else {
          toast.error("PDF could not be sent at this time, please try again later!");
        }
        setLoading(false);
      });
      return isSuccess;
    } else {
      setLoading(false);
      toast.error("Failed to upload PDF, please try again later!");
      return false;
    }
  } catch (error) {
    console.error("Error in uploadBlobAndSendEmail:", error);
    toast.error("An error occurred while sending the PDF. Please try again later!");
    setLoading(false);
    return false;
  }
};
// export const uploadBlobAndSendEmail = async (
//   pdfBlob,
//   filename,
//   docId,
//   docType,
//   collection,
//   setLoading,
//   docNumber,
//   email,
//   type,
//   pdfLink,
//   ccEmails
// ) => {
//   setLoading(true);

//   if (type === 'resend' && pdfLink) {
//     let obj = {
//       email: email,
//       pdfLink: pdfLink,
//       documentType: docType,
//       documentNumber: docNumber,
//       ccEmails: [ccEmails]
//     };
//     await sendingEmail(obj, (res) => {
//       if (res.status == 200) {
//         toast.success("Pdf Resent successfully");
//       } else {
//         toast.error("Pdf could not be sent at this time, please try again later!");
//       }
//       setLoading(false);
//     });
//   } else {
//     uploadPDFBlob(pdfBlob, filename).then(async (response) => {
//       try {
//         if (response) {
//           let obj = {
//             email: email,
//             pdfLink: response,
//             documentType: docType,
//             documentNumber: docNumber,
//             ccEmails: [ccEmails]
//           };
//           await sendingEmail(obj, (res) => {
//             if (res.status == 200) {
//               saveData(collection, docId, {
//                 sendPdf: true,
//                 pdfLink: response,
//               });
//               toast.success("Pdf sent successfully");
//             } else {
//               toast.error("Pdf could not be sent at this time, please try again later!");
//             }
//             setLoading(false);
//           });
//         } else {
//           setLoading(false);
//           toast.error("Pdf could not be sent at this time, please try again later!");
//         }
//       } catch (error) {
//         console.error("🔥 Error in .then() block:", error);
//       }
//     });
//   }
// };
export const sendCancellationEmail = async (email, docType, docNumber, ccEmails, setLoading, type, onSuccess) => {
  setLoading(true);
  if (type === 'cancel') {
    let obj = {
      email: email,
      documentType: docType,
      documentNumber: docNumber,
      ccEmails: [ccEmails]
    };
    let isSuccess = false;
    await sendSimpleEmailApi(obj, (res) => {
      if (res.status == 200) {
        toast.success("Email has Sent to Vendor for Purchase Order Cancellation");
        isSuccess = true;
        if (typeof onSuccess === "function") {
          onSuccess(res);
        }
      } else {
        toast.error("Pdf could not be sent at this time, please try again later!");
      }
      setLoading(false);
    });
    return isSuccess;
  }
  return false;
};
// utils.js
export function formatNumberWithCommas(number) {
  // Convert the number to a string if it's not already
  const numberStr = number.toString();
  // Split the number into integer and decimal parts
  const [integerPart, decimalPart] = numberStr.split('.');
  // Add commas to the integer part
  const integerWithCommas = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  // Return the formatted number with or without decimal part
  return decimalPart ? `${integerWithCommas}.${decimalPart}` : integerWithCommas;
}
